module.exports = __webpack_public_path__ + "static/media/edenred-logo.4f61a6e3.svg";